function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M853.334 1023.98H170.666a56.89 64 0 0 1-56.89-64v-704a56.89 64 0 0 1 56.89-64h113.778v64a56.89 64 0 0 0 56.889 64h341.334a56.89 64 0 0 0 56.89-64v-64h113.777a56.89 64 0 0 1 56.89 64v704a56.89 64 0 0 1-56.89 64m-50.63-492.8-154.17 167.807-174.479-190.336-253.384 276.224 41.13 44.8L474.056 598.38l174.479 190.336 195.3-212.736Zm-176.926-275.2H398.222a56.89 64 0 0 1 0-128h56.889v-64a56.89 64 0 0 1 113.778 0v64h56.89a56.89 64 0 0 1 0 128",
    style: {
      strokeWidth: 1.06067
    }
  }));
};
export default SvgAnalytics;